import {useNavigate} from "react-router-dom";
import {Ajax} from "../../Service/ajax";
import Swal from "sweetalert2";
export default function TableOrganisation({ title, content }) {
    const navigate = useNavigate();
    const session = sessionStorage.getItem("session");
    const trf = sessionStorage.getItem("trf");

    const createApp = (name,organisation_id,description) => {
        const requestData = {
            title: name,
            organisation_id:organisation_id,
            description: description
        };
        const fetchApp = async () => {
            try {
                const {data} = await Ajax.postRequest(`/api/v1/sub/application/create`,requestData);
                if(data.error){

                    Swal.fire({
                        title: 'Error!',
                        text:`${data.message}`,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        customClass: {
                            popup: 'custom-popup',
                            confirmButton: 'custom-button'
                        },
                        timer: 5000,
                        timerProgressBar: true,
                    });
                }else{
                    Swal.fire({
                        title: 'Success',
                        text:`Une application a ete associe a votre orgnisation avec success`,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        customClass: {
                            popup: 'custom-popup',
                            confirmButton: 'custom-button'
                        },
                        timer: 5000,
                        timerProgressBar: true,
                        didClose: () => {
                            retrieveApp(organisation_id);
                        }
                    });
                }
            } catch (error) {
                Swal.fire({
                    title: 'Error!',
                    text:`Oups! Une erreur s'est produite, veuillez reesayer plus tard.`,
                    icon: 'error',
                    confirmButtonText: 'OK',
                    customClass: {
                        popup: 'custom-popup',
                        confirmButton: 'custom-button'
                    },
                    timer: 5000,
                    timerProgressBar: true,
                });
            }
        };
        fetchApp();
    };


    const retrieveApp = async (company_id) => {
        try {
            const {data} = await Ajax.getRequest(`/api/v1/sub/application/retrieve/${company_id}`);
            console.log(data)
            if (data.error) {
                if(data.message === "application n'existe pas"){
                    Swal.fire({
                        title: 'Message important',
                        text: "Votre organisation n'est pas encore associée à une application. Souhaitez-vous l'associer afin de pouvoir continuer ?",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor:'#debf66',
                        focusConfirm:true,
                        confirmButtonText: 'Oui',
                        cancelButtonText:'Non'
                    }).then(async (result) => {
                        if (result.isConfirmed) {
                            let company = content.find(company => company.id === company_id);
                            if (company) {
                                createApp(company.name, company.id, company.description)
                            }else{
                                Swal.fire({
                                    title: 'Error!',
                                    text:`Oups! Une erreur s'est produite, veuillez reesayer plus tard.`,
                                    icon: 'error',
                                    confirmButtonText: 'OK',
                                    customClass: {
                                        popup: 'custom-popup',
                                        confirmButton: 'custom-button'
                                    },
                                    timer: 5000
                                });
                            }
                        }
                    })
                }else{

                    Swal.fire({
                        title: 'Error!',
                        text:`${data.message}`,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        customClass: {
                            popup: 'custom-popup',
                            confirmButton: 'custom-button'
                        },
                        timer: 5000
                    });
                }
            } else {
                let company = content.find(company => company.id === company_id);
                if (company) {
                    sessionStorage.setItem("application", JSON.stringify(data.object));
                    sessionStorage.setItem("company", JSON.stringify(company));
                    navigate("/application");
                }
            }
        } catch (error) {
            navigate("/error-page", { state: { errorCode: error.response.status } });
        }
    };
    const handleClick = (id) => {
        if(!session){
            navigate('/');
        }else{
            retrieveApp(id);
        }
    };

    const handleShare = async (company_id) => {
        const ref=JSON.parse(trf)
        const {data} = await Ajax.getRequest(`/api/v1/sub/application/retrieve/${company_id}`);
        const url=window.location.origin+`/page?user=${data.object.id}&cmp=${company_id}&ref=${ref.trf_id}`
        Swal.fire({
            title: 'Partager sur les réseaux sociaux',
            html: `
          <div class="social-icons">
            <input type="hidden" id="fb01" value=${url}>
            <img type="button" onclick="window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(document.getElementById('fb01').value),'_blank')" class="w-25" src="https://static.vecteezy.com/system/resources/previews/018/930/698/original/facebook-logo-facebook-icon-transparent-free-png.png" id="facebookShare" alt="Facebook">
            <img type="button" onclick="window.open('https://www.linkedin.com/sharing/share-offsite/?url=' + encodeURIComponent(document.getElementById('fb01').value),'_blank')" class="w-25" src="https://static.vecteezy.com/system/resources/previews/018/930/587/original/linkedin-logo-linkedin-icon-transparent-free-png.png" id="linkedInShare" alt="Linkedin">
            <img type="button" onclick="window.open('https://api.whatsapp.com/send?text=' + encodeURIComponent(document.getElementById('fb01').value),'_blank')" class="w-25" src="https://static.vecteezy.com/system/resources/previews/018/930/746/non_2x/whatsapp-logo-whatsapp-icon-whatsapp-transparent-free-png.png" id="whatsappShare" alt="Whatsapp">
          </div>
        `,
            showCloseButton: false,
            showConfirmButton: false,
        });
    }

    return (
        <div className={"card"}>
            <h5 className="card-header">{title}</h5>
            <div className="table-responsive text-nowrap">
                <table className="table table-hover mb-5">
                    <thead>
                    <tr>
                        <th>Nom</th>
                        <th>Categorie</th>
                        <th>Certifié</th>
                        <th>Status</th>
                        <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody className="table-border-bottom-0">
                    {content.map((item, index) => (
                        <tr key={index}>
                            <td>{item.name}</td>
                            <td>{item.category}</td>
                            <td>
                                {item.certified ===false && (
                                    <>
                                    <span className="badge bg-label-info">NON</span>
                                    </>
                                )}
                                {item.certified === true && (
                                    <>
                                        <span className="badge bg-label-success">OUI</span>
                                    </>
                                )}
                            </td>
                            <td>
                                {item.enabled === false && !item.locked && (
                                    <span className="badge bg-label-info">En cours d'activation</span>
                                )}
                                {item.enabled === true && !item.locked && (
                                    <span className="badge bg-label-success">Activé</span>
                                )}
                                {item.locked && (
                                    <span className="badge bg-label-danger">Bloqué</span>
                                )}
                            </td>

                            {content.length > 0 && item.enabled === true && !item.locked && item.wallet_type_id !== null ? (
                                <td>
                                    <button
                                        style={{
                                            backgroundColor: '#fdce5b', // Colore le bouton en vert
                                            color: 'white', // Texte en blanc
                                            padding: '10px 20px', // Taille de rembourrage interne
                                            borderRadius: '8px', // Coins arrondis
                                            border: 'none', // Supprime la bordure
                                            cursor: 'pointer', // Change le curseur lors du survol
                                            fontSize: '12px', // Taille du texte
                                            textTransform: 'uppercase', // Texte en majuscules
                                            fontWeight: 'bold', // Texte en gras
                                            transition: 'background-color 0.3s ease', // Transition d'arrière-plan
                                        }}
                                        onMouseEnter={(e) => (e.target.style.backgroundColor = '#eccd7e')} // Changement de couleur au survol
                                        onMouseLeave={(e) => (e.target.style.backgroundColor = '#eac35e')} // Retour à la couleur normale
                                        onClick={() => handleClick(item.id)}
                                    >
                                        Gerer mon organisation
                                    </button>
                                    {/*<div className="btn-group" role="group" aria-label="Third group">*/}
                                    {/*    <button type="button" className="btn btn-outline-netikash"*/}
                                    {/*            data-bs-toggle="tooltip"*/}
                                    {/*            data-bs-offset="0,8" data-bs-placement="top"*/}
                                    {/*            data-bs-custom-class="tooltip-dark" title="Voir Plus"*/}
                                    {/*            onClick={() => handleClick(item.id)}>*/}
                                    {/*        <i className='bx bx-show-alt'></i>*/}
                                    {/*    </button>*/}
                                    {/*    <button type="button" className="btn btn-outline-netikash"*/}
                                    {/*            data-bs-toggle="tooltip"*/}
                                    {/*            data-bs-offset="0,8" data-bs-placement="top"*/}
                                    {/*            data-bs-custom-class="tooltip-dark" title="Partager"*/}
                                    {/*            onClick={() => handleShare(item.id)}>*/}
                                    {/*        <i className="bx bxs-share-alt me-1"></i>*/}
                                    {/*    </button>*/}
                                    {/*    <button type="button" className="btn btn-outline-netikash"*/}
                                    {/*            data-bs-toggle="tooltip"*/}
                                    {/*            data-bs-offset="0,8" data-bs-placement="top"*/}
                                    {/*            data-bs-custom-class="tooltip-dark" title="Faire un retrait"*/}
                                    {/*            onClick={() => navigate("/withdrawal-request", {state: {item}})}>*/}
                                    {/*        <i className='bx bx-money'></i>*/}
                                    {/*    </button>*/}
                                    {/*</div>*/}

                                </td>
                            ) : null}
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}